import React from "react";
import classNames from "classnames";
import ReactMarkdown from "markdown-to-jsx";

import styles from "./commonHero.module.css";

type CommonHeroProps = {
  title: React.ReactNode | string;
  subtitle?: string | null;
  brandColor: "pro-blue" | "cerise" | null;
  wrapperClassNames?: string;
  containerClassNames?: string;
  titleClassNames?: string;
  subtitleClassNames?: string;
};

const CommonHero = ({
  title,
  subtitle,
  brandColor,
  wrapperClassNames,
  containerClassNames,
  titleClassNames,
  subtitleClassNames,
}: CommonHeroProps) => {
  return (
    <div
      data-testid={"commonHero__wrapper"}
      className={classNames(
        "flex min-h-[193px] items-center bg-[length:32px_32px] px-[20px] py-[25px] md:h-[193px] md:py-0 lg:px-0",
        wrapperClassNames,
        {
          [styles.backgroundGrid]:
            brandColor === "cerise" || brandColor === null,
          [styles.backgroundGridBlue]: brandColor === "pro-blue",
        }
      )}
    >
      <div className={"mx-auto h-full w-full"}>
        <div
          data-testid={"commonHero__container"}
          className={classNames(
            "mx-auto flex h-full max-w-[1000px] flex-col justify-center",
            containerClassNames
          )}
        >
          <h1
            data-testid={"commonHero__title"}
            className={classNames(
              "inline-flex font-recklessBold text-[32px] leading-[120%] md:text-[52px]",
              {
                "text-pro-blue": brandColor === "pro-blue",
                "text-cerise": brandColor === "cerise",
              },
              titleClassNames
            )}
          >
            {title}
          </h1>
          {subtitle && (
            <div
              data-testid={"commonHero__subtitle"}
              className={classNames(
                subtitleClassNames
                  ? subtitleClassNames
                  : "mt-2 self-end md:w-3/4 lg:w-2/3"
              )}
            >
              <div className="text-[16px] leading-[130%]">
                <ReactMarkdown
                  options={{ forceBlock: true }}
                  className={classNames(
                    "[&_p]:m-0",
                    "[&_a]:inline [&_a]:underline [&_a]:[text-underline-position:under]",
                    "focus:[&_a]:outline-none focus-visible:[&_a]:outline-none focus-visible:[&_a]:ring",
                    {
                      "[&_a]:text-pro-blue focus-visible:[&_a]:ring-pro-blue":
                        brandColor === "pro-blue",
                      "[&_a]:text-cerise focus-visible:[&_a]:ring-cerise":
                        brandColor !== "pro-blue",
                    }
                  )}
                >
                  {subtitle}
                </ReactMarkdown>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommonHero;
